import { GET_ALL_SAMPLE_LIST, CREATE_SAMPLE_LIST, UPDATE_SAMPLE_LIST} from '../actiontypes';
import { HTTP_REQUEST_METHODS } from "../../util/api";
import {createApiReadAction, createApiCreateAction, createApiUpdateAction, API_RESOURCES} from '../../util/api';
import Utility from '../../util/utilityfunctions';
import {jsonDocumentPatchOperations} from '../../util/uiconstants';

export const getSampleListId = (engagementId, queryParams) => {
    return createApiReadAction(
        GET_ALL_SAMPLE_LIST,
        {
            [API_RESOURCES.ENGAGEMENTS]: engagementId,
            [API_RESOURCES.SAMPLELISTS]: undefined
        },
        queryParams,
        { resolve: true }
    );
}
export function createSampleList(engagementId, payload) {
	return createApiCreateAction(
		CREATE_SAMPLE_LIST,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
            [API_RESOURCES.SAMPLELISTS]: undefined
		},
		payload
	);
}
export const updateSampleList = (engagementId, sampleListId, documentId, expectedItemCount) =>
    createApiUpdateAction(
        UPDATE_SAMPLE_LIST,
        {
            [API_RESOURCES.ENGAGEMENTS]: engagementId,
            [API_RESOURCES.SAMPLELISTS]: sampleListId
        },
        [
            Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.add, "/expectedItemCount", expectedItemCount),
            Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.add, "/documentId", documentId)
        ],
        HTTP_REQUEST_METHODS.PATCH
    );